import axios from "@/api/axios";

// const addTooth = (newTooth) => {
//   let formData = new FormData();
//   formData.append("toothFile", newTooth.file);
//   const response = axios({
//     method: "POST",
//     url: "/api/tooth/add",
//     data: formData,
//     headers: {
//       "Content-Type": "multipart/form-data; boundary=${form._boundary}",
//     },
//   });
//   return axios.get(apiUrl);
// };

async function sendAddToothRequest(tooth) {
  console.log("sendAddToothRequest", tooth);
  if (tooth && tooth.file) {
    let url = "/api/tooth/add";
    let formData = new FormData();
    formData.append("file", tooth.file);
    formData.append("patientId", vueApp.patientId);
    formData.append("s3Path", vueApp.stlBaseUrl);
    formData.append("number", tooth.number);
    formData.append("numberType", tooth.numberType);
    formData.append("remarks", tooth.remarks);
    formData.append("smooth", false); //tooth.smooth
    let config = {};
    config.headers = {
      "content-type": "multipart/form-data",
    }; // ; boundary=${form._boundary}

    let response = null;
    try {
      response = await axios.post(url, formData, config);
    } catch (e) {
      console.log("sendAddToothRequest", e);
    }
    return response;
  }
}

async function sendSmoothStlRequest(file, factor, isLayered) {
  console.log("sendSmoothStlRequest", factor, isLayered);
  if (file) {
    let url = "/api/tooth/smoothStl";
    let formData = new FormData();
    formData.append("file", file);
    if (factor) formData.append("factor", factor);
    formData.append("isLayered", !!isLayered);

    let config = {
      responseType: "blob",
    };
    config.headers = {
      "X-Requested-With": "XMLHttpRequest",
      "content-type": "multipart/form-data",
    }; // ; boundary=${form._boundary}

    const response = await axios.post(url, formData, config);

    return response;
  }
}

async function getNerveStlFromPoints(points) {
  console.log("getNerveStlFromPoints", points);
  try {
    if (points && points.length) {
      let url = "/api/nerve/getNerveStlFromPoints";

      let stringData = JSON.stringify(points);
      let config = {};
      config.headers = {
        "content-type": "application/json",
      };
      config.responseType = "arraybuffer";

      const response = await axios.post(url, stringData, config);
      console.log("getNerveStlFromPoints response", response);
      return response;
    }
  } catch (error) {
    console.log("getNerveStlFromPoints error", error);
  }
}

async function sendUpdateTeethRequest(blob) {
  let url = "/api/tooth/updateTeeth";
  let formData = new FormData();
  formData.append("file", blob, `teeth_${vueApp.patientId}.zip`);
  formData.append("patientId", vueApp.patientId);
  formData.append("s3Path", vueApp.stlBaseUrl);
  formData.append("isStaging", !!vueApp.isStaging);

  let config = {};
  config.headers = {
    "content-type": "multipart/form-data",
  }; // ; boundary=${form._boundary}

  const response = await axios.post(url, formData, config);
  return response;
}

async function sendRemoveTeethRequest(teeth) {
  if (teeth && teeth.length) {
    let url = "/api/tooth/removeTeeth";
    let filenames = teeth.map((x) => x.filename);
    console.log("sendRemoveTeethRequest request", filenames);
    let data = {
      patientId: vueApp.patientId,
      s3Path: vueApp.stlBaseUrl,
      filenames: filenames,
    };
    let stringData = JSON.stringify(data);
    let config = {};
    config.headers = {
      "content-type": "application/json",
    };
    const response = await axios.post(url, stringData, config);
    console.log("sendRemoveTeethRequest response", response);
    return response;
  }
}

async function checkPatientIsRestitching(patientId) {
  try {
    let url = `/api/tooth/checkPatientIsRestitching?patientId=${patientId}&isStaging=${!!vueApp.isStaging}`;
    // let url = 'https://qa.ceph-x.com/cephx/tasksByPatientId/crown-composition?patientId=317516';
    const response = await axios.get(url, patientId);
    const responseData = response.data;
    // console.log("checkPatientIsRestitching responseData", responseData);
    return responseData.value;
  } catch (e) {
    // console.log("checkPatientIsRestitching error", e);
    return false;
  }
}

async function getLastStitchingResult(patientId) {
  try {
    let url = `/api/tooth/getLastStitchingResult?patientId=${patientId}&isStaging=${!!vueApp.isStaging}`;
    const response = await axios.get(url, patientId);
    const responseData = response.data;
    return responseData; //.value;
  } catch (e) {
    return { value: null };
  }
}

async function getTimeStamps(patientId) {
  try {
    let url = `/api/tooth/getTimeStamps?patientId=${patientId}&isStaging=${!!vueApp.isStaging}`;
    const response = await axios.get(url, patientId);
    const responseData = response.data;
    return responseData; //.value;
  } catch (e) {
    return null;
  }
}

async function sendResetCaseRequest() {
  console.log("sendResetCaseRequest");
  let url = "/api/tooth/resetCase";
  let formData = new FormData();
  formData.append("patientId", vueApp.patientId);
  formData.append("s3Path", vueApp.stlBaseUrl);
  let config = {};
  config.headers = {
    "content-type": "multipart/form-data",
  };

  let urls = null;
  try {
    let response = await axios.post(url, formData, config);
    console.log("sendResetCaseRequest response", response);
    urls = response.data.value;
  } catch (e) {
    console.log("sendResetCaseRequest error", e);
  }
  return urls;
}

export {
  sendResetCaseRequest,
  sendAddToothRequest,
  sendSmoothStlRequest,
  sendRemoveTeethRequest,
  sendUpdateTeethRequest,
  checkPatientIsRestitching,
  getLastStitchingResult,
  getTimeStamps,
  getNerveStlFromPoints,
};
